import React, { Component } from "react";
import { cmsAccount, msHeaders } from "../components/NavMenu";
import "./css/Device.css";
import { IconButton } from "../components/IconButton";
import { DeviceInfoModal } from "../components/DeviceInfoModal";
import { withTranslation } from "react-i18next";
import { DeviceSetupModal } from "../components/DeviceSetupModal";
import { WarningBox } from "../components/WarningBox";

class Device extends Component {
    constructor(props) {
        super(props);

        this.state = {
            devices: [],
            selectedDevice: null,
            deviceInfoShown: false,
            deviceSetupModal: false,
            location: [],
            showWarningBox: false,
            toDelDevice: {},
        };
    }

    componentDidMount() {
        const intervalId = setInterval(() => {
            if (cmsAccount) {
                this.fetchLocation();
                this.fetchDevices("loc-all");
                clearInterval(intervalId);
            }
        }, 100);
    }

    fetchDevices(locationId) {
        var requestOptions = {
            method: "GET",
            headers: msHeaders,
            redirect: "follow",
        };
        if (locationId == "loc-all") {
            fetch(`/api/devices/`, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    console.log(result);
                    this.setState({ devices: result });
                });
        } else {
            fetch(`/api/locations/${locationId}/devices/`, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    console.log(result);
                    this.setState({ devices: result });
                });
        }
    }

    showMore(id) {
        const { devices } = this.state;
        this.setState({
            deviceInfoShown: true,
            selectedDevice: devices[id],
        });
    }

    unregister(deviceId) {
        var requestOptions = {
            method: "PUT",
            headers: msHeaders,
            redirect: "follow",
        };

        return fetch(`/api/devices/${deviceId}/unregister`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                console.log(result);
                this.fetchDevices("loc-all");
            });
    }

    fetchLocation() {
        var requestOptions = {
            method: "GET",
            headers: msHeaders,
            redirect: "follow",
        };

        fetch(`/api/locations/`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                this.setState({ location: result });
            });
    }

    selectLoc() {
        var menu = document.getElementById("location-menu");
        const locationId = menu.options[menu.selectedIndex].id;
        this.fetchDevices(locationId);
    }

    render() {
        const { t } = this.props;
        const { devices, selectedDevice, deviceInfoShown, deviceSetupModal, location, showWarningBox, toDelDevice } = this.state;
        return (
            <>
                <div className="device-page">
                    <div className="menu-container">
                        Location:
                        <select
                            className="form-select location-menu"
                            aria-label="Default select"
                            id="location-menu"
                            onChange={() => {
                                this.selectLoc();
                            }}
                        >
                            <option defaultChecked id="loc-all">
                                All
                            </option>
                            {location.map((loc) => {
                                return (
                                    <option key={loc.uuid} id={loc.uuid}>
                                        {loc.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div className="title">
                        <div className="text" style={{ marginLeft: "80px" }}>
                            {t("device-deviceName")}
                        </div>
                        <div className="text" style={{ marginLeft: "284px" }}>
                            {t("device-online")}
                        </div>
                        <div className="text" style={{ marginLeft: "115px" }}>
                            {t("device-power")}
                        </div>
                        <div className="text" style={{ marginLeft: "134px" }}>
                            {t("device-lastSync")}
                        </div>
                        <div className="text" style={{ marginLeft: "125px" }}>
                            {t("device-playlist")}
                            <br />
                            {t("device-version")}
                        </div>
                    </div>
                    <div className="device-set">
                        {devices.map((device, index) => {
                            const powerType = device.powerType;
                            const battery = Number(device.battery);

                            let powerIcon = "";
                            if (powerType == "charging" || powerType == "usbc") {
                                powerIcon = "icons/charging.svg";
                            } else if (powerType == "battery") {
                                if (battery >= 0) powerIcon = "icons/battery-20.svg";
                                if (battery > 33) powerIcon = "icons/battery-60.svg";
                                if (battery > 66) powerIcon = "icons/battery-100.svg";
                            } else {
                                powerIcon = "icons/battery-unknown.svg";
                            }
                            const lastSyncTime = new Date(device.lastConnected);
                            const syncTimeStr = lastSyncTime.toLocaleString();
                            const interval = (new Date().getTime() - lastSyncTime.getTime()) / 1000 / 60 / 60;
                            const isOnline = interval < 24;
                            if (!isOnline) powerIcon = "icons/battery-unknown.svg";
                            return (
                                <div className="device-item" key={index}>
                                    <div className="device-name">{device.name}</div>
                                    <div className="device-status">
                                        {isOnline ? <img src="icons/online.svg" /> : <img src="icons/offline.svg" />}
                                    </div>
                                    <div className="battery-status">
                                        <img src={powerIcon} />
                                    </div>
                                    <div className="last-sync">
                                        <div className="text">{syncTimeStr}</div>
                                    </div>
                                    {device.version == device.telemetryVer ? (
                                        <div className="compatibility-status">
                                            Newest
                                            <img className="icon" src="icons/link.svg" />
                                            Newest
                                        </div>
                                    ) : (
                                        <div className="compatibility-status" style={{ color: "#808080" }}>
                                            Old
                                            <img className="icon" src="icons/unmatch.svg" />
                                            Newest
                                        </div>
                                    )}

                                    <IconButton
                                        onClick={() => {
                                            this.showMore(index);
                                        }}
                                        src="icons/more.svg"
                                        srcWhite="icons/more-white.svg"
                                    />
                                    <IconButton
                                        onClick={() => {
                                            this.setState({
                                                showWarningBox: true,
                                                toDelDevice: device,
                                            });
                                        }}
                                        src="icons/delete.svg"
                                        srcWhite="icons/delete-white.svg"
                                    />
                                </div>
                            );
                        })}
                        {/* <button className='add-button' onClick={() => { this.setState({ deviceSetupModal: true }) }}>
                            <img src='icons/add-white.svg' width={40} />
                        </button> */}
                    </div>
                </div>
                <DeviceInfoModal
                    device={selectedDevice}
                    shown={deviceInfoShown}
                    closeModal={() => {
                        this.setState({ deviceInfoShown: false });
                    }}
                />
                <DeviceSetupModal
                    shown={deviceSetupModal}
                    closeModal={() => {
                        this.setState({ deviceSetupModal: false });
                        this.selectLoc();
                    }}
                />
                <WarningBox
                    shown={showWarningBox}
                    message={`Unregister ${toDelDevice.name}`}
                    description={"Are you sure to unregister this device?"}
                    close={(yes) => {
                        if (yes) {
                            this.unregister(toDelDevice.uuid);
                        }
                        this.setState({ showWarningBox: false });
                    }}
                />
            </>
        );
    }
}

export default withTranslation()(Device);
